export default __webpack_public_path__ + "static/media/BR.45dbeec4.svg";